/* Douce Patte · comportements premium (refonte oct. 2026). Aucune dépendance. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Apparition au défilement */
  function initLegacyReveal(root) {
    var els = (root || document).querySelectorAll('[data-reveal]:not(.is-visible), [data-reveal-stagger]:not(.is-visible)');
    function show(el) {
      if (el.hasAttribute('data-reveal-stagger')) Array.prototype.forEach.call(el.children, function (c, i) { c.style.transitionDelay = i * 60 + 'ms'; });
      el.classList.add('is-visible');
    }
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(show); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initReveal(root) {
    initLegacyReveal(root);
    var els = (root || document).querySelectorAll('.dp-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Vidéos en boucle : ne jouent que visibles à l'écran */
  function initAutoVideos(root) {
    var vids = (root || document).querySelectorAll('video[data-dp-autoplay]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && !reduce) {
          if (v.preload === 'none') v.preload = 'auto';
          v.play().catch(function () {});
        } else { v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  }

  /* Rails horizontaux : flèches + barre de progression */
  function initRails(root) {
    (root || document).querySelectorAll('[data-dp-rail]').forEach(function (wrap) {
      if (wrap.dataset.dpReady) return; wrap.dataset.dpReady = '1';
      var rail = wrap.querySelector('.dp-rail'); if (!rail) return;
      var prev = wrap.querySelector('[data-dp-prev]'), next = wrap.querySelector('[data-dp-next]');
      var bar = wrap.querySelector('.dp-progress span');
      function step() { var c = rail.children[0]; return c ? c.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8; }
      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        var p = max > 0 ? rail.scrollLeft / max : 0;
        if (prev) prev.disabled = rail.scrollLeft < 4;
        if (next) next.disabled = rail.scrollLeft > max - 4;
        if (bar) {
          var ratio = rail.clientWidth / rail.scrollWidth;
          bar.style.width = Math.max(ratio * 100, 8) + '%';
          bar.style.transform = 'translateX(' + (p * (100 / Math.max(ratio, 0.08) - 100)) + '%)';
        }
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* Héros : défilement automatique + points */
  function initHero(root) {
    (root || document).querySelectorAll('[data-dp-hero]').forEach(function (hero) {
      if (hero.dataset.dpReady) return; hero.dataset.dpReady = '1';
      var track = hero.querySelector('.dp-hero__track');
      var slides = Array.prototype.slice.call(hero.querySelectorAll('.dp-hero__slide'));
      var dots = Array.prototype.slice.call(hero.querySelectorAll('.dp-hero__dot'));
      var delay = (parseInt(hero.dataset.delay, 10) || 7) * 1000;
      hero.style.setProperty('--dp-hero-delay', delay / 1000 + 's');
      var i = 0, timer = null, paused = false;
      function playMedia(idx) {
        slides.forEach(function (s, k) {
          var v = s.querySelector('video');
          if (!v) return;
          if (k === idx && !reduce) { v.play().catch(function () {}); } else { v.pause(); }
        });
      }
      function go(n, smooth) {
        i = (n + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        dots.forEach(function (d) { var s = d.querySelector('span'); if (s) { s.style.animation = 'none'; void s.offsetWidth; s.style.animation = ''; } });
        playMedia(i); schedule();
      }
      function schedule() {
        clearTimeout(timer);
        if (slides.length < 2 || paused || reduce) return;
        timer = setTimeout(function () { go(i + 1); }, delay);
      }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var n = Math.round(track.scrollLeft / track.clientWidth);
          if (n !== i) { i = n; dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); }); playMedia(i); schedule(); }
        }, 120);
      }, { passive: true });
      hero.addEventListener('mouseenter', function () { paused = true; clearTimeout(timer); });
      hero.addEventListener('mouseleave', function () { paused = false; schedule(); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else schedule(); });
      playMedia(0); schedule();
    });
  }

  /* Barre d'ancres de la fiche produit */
  function initAnchors() {
    var bar = document.querySelector('[data-dp-anchors]');
    if (!bar || bar.dataset.dpReady) return; bar.dataset.dpReady = '1';
    var links = Array.prototype.slice.call(bar.querySelectorAll('.dp-anchors__nav a'));
    links = links.filter(function (a) {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (!t) { a.remove(); return false; }
      return true;
    });
    var form = document.querySelector('product-info .product-form, product-info form[action*="/cart/add"]') || document.querySelector('.product__info-container');
    if ('IntersectionObserver' in window && form) {
      new IntersectionObserver(function (en) {
        var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
      }).observe(form);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + en.target.id); });
          }
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      links.forEach(function (a) { var t = document.getElementById(a.getAttribute('href').slice(1)); if (t) io.observe(t); });
    }
    var buy = bar.querySelector('[data-dp-buy]');
    if (buy) buy.addEventListener('click', function (e) {
      var target = document.querySelector('product-info') || document.querySelector('.product');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* Vidéo « Comment ça marche » : lecture avec son au clic */
  function initHowto(root) {
    (root || document).querySelectorAll('[data-dp-howto]').forEach(function (box) {
      if (box.dataset.dpReady) return; box.dataset.dpReady = '1';
      var v = box.querySelector('video'), b = box.querySelector('.dp-howto__play');
      if (!v || !b) return;
      b.addEventListener('click', function () {
        v.muted = false; v.controls = true; v.preload = 'auto';
        v.play().catch(function () {}); box.classList.add('is-playing');
      });
    });
  }


  /* Panier tiroir : ajout d'une suggestion + jauge hors euro */
  function refreshDrawer(json) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && json && json.sections) { drawer.renderContents(json); }
    else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
  }
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-dp-up-sel]');
    if (sel) { var btn = sel.closest('.dp-up').querySelector('[data-dp-up-add]'); if (btn) btn.setAttribute('data-dp-up-add', sel.value); }
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-dp-up-add]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-dp-up-add'), 10), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { btn.removeAttribute('aria-busy'); refreshDrawer(j); })
      .catch(function () { btn.removeAttribute('aria-busy'); });
  });

  /* API panier partagée (combo, suggestions) : ajoute puis ouvre le tiroir Dawn */
  window.DoucePatte = window.DoucePatte || {};
  window.DoucePatte.cart = {
    add: function (items) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) { refreshDrawer(j); return j; });
    }
  };

  function shipGauge() {
    document.querySelectorAll('[data-dp-ship]').forEach(function (g) {
      var cur = g.dataset.currency, total = parseInt(g.dataset.total, 10) || 0, th = parseInt(g.dataset.thresholdEur, 10) || 7000;
      if (cur !== 'EUR' && window.Shopify && Shopify.currency && Shopify.currency.rate) th = Math.round(th * (parseFloat(Shopify.currency.rate) || 1));
      var bar = g.querySelector('[data-dp-ship-bar]'); if (bar) bar.style.width = Math.min(100, Math.round(total * 100 / th)) + '%';
    });
  }
  shipGauge();
  if ('MutationObserver' in window) {
    var cd = document.querySelector('cart-drawer');
    if (cd) new MutationObserver(function () { shipGauge(); }).observe(cd, { childList: true, subtree: true });
  }

  function initAll(root) { initReveal(root); initAutoVideos(root); initRails(root); initHero(root); initHowto(root); initAnchors(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
